function debounce(callback, delay: number) {
  let timeoutHandler: number | undefined | null = null;
  return function () {
    clearTimeout(timeoutHandler);
    timeoutHandler = setTimeout(function () {
      callback();
    }, delay);
  };
}

export default defineNuxtPlugin(() => {
  if (window && document) {
    const setVH = () => {
      document.documentElement.style.setProperty(
        '--fullvh',
        window.innerHeight + 'px'
      );
    };
    window.addEventListener('resize', debounce(setVH, 300));
    setVH();
  }
});
